// ============================================================================
// BUCKET SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'bucket-sort',
  name: 'Bucket Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n + k) average, O(n²) worst',
    space: 'O(n + k)'
  },
  description: 'Bucket Sort is a distribution sort that distributes elements into buckets, sorts each bucket individually, and concatenates the results. It achieves linear time for uniformly distributed data.'
};
export type MetaType = typeof meta;
